import { DateRange } from '@clickcease/cc-client-components-lib'
import { create, StateCreator } from 'zustand'
import { devtools } from 'zustand/middleware'
import { ASC, DirectionType } from 'Types/tables'
import { baseRangeOptions } from 'Components/Elements/DateRange/utilities'

export const ACTIVE_DOMAIN_SORT_KEYS = {
  ADDRESS: 'address',
  BOT_MITIGATION_TREND: 'botMitigationInvalidTrend',
  PAID_MARKETING_TREND: 'paidMarketingInvalidTrend',
} as const

export type DomainSortKeys = (typeof ACTIVE_DOMAIN_SORT_KEYS)[keyof typeof ACTIVE_DOMAIN_SORT_KEYS]
export interface OverallDomainPerformanceStore {
  selectedDates: DateRange
  setSelectedDates: (dates: DateRange) => void
  botMitigationDataIsLoading: boolean
  setBotMitigationDataIsLoading: (isLoading: boolean) => void
  sortDomainsBy: DomainSortKeys | undefined
  setSortDomainsBy: (sortBy: string) => void
  sortDirection: DirectionType
  setSortDirection: (direction: DirectionType) => void
  searchText: string
  setSearchText: (searchText: string) => void
}

const dateRange = baseRangeOptions.WEEK.range

const overallDomainPerformanceStore = (
  set: (fn: () => Partial<OverallDomainPerformanceStore>) => void
) => ({
  selectedDates: dateRange,
  setSelectedDates: (dates: { from: Date; to: Date }) => {
    set(() => ({ selectedDates: dates }))
  },
  botMitigationDataIsLoading: false,
  setBotMitigationDataIsLoading: (isLoading: boolean) => {
    set(() => ({ botMitigationDataIsLoading: isLoading }))
  },
  sortDomainsBy: undefined,
  setSortDomainsBy: (sortBy: DomainSortKeys) => {
    set(() => ({ sortDomainsBy: sortBy }))
  },
  sortDirection: ASC,
  setSortDirection: (direction: DirectionType) => {
    set(() => ({ sortDirection: direction }))
  },
  searchText: '',
  setSearchText: (searchText: string) => {
    set(() => ({ searchText: searchText }))
  },
})

const useOverallDomainPerformanceStore = create<OverallDomainPerformanceStore>()(
  devtools(
    overallDomainPerformanceStore as StateCreator<
      OverallDomainPerformanceStore,
      [['zustand/devtools', never]],
      [],
      OverallDomainPerformanceStore
    >
  )
)
export default useOverallDomainPerformanceStore
